module.exports = __webpack_public_path__ + "img/9-1.360098e4.png";